export default __webpack_public_path__ + "static/media/photo--lg--38.7e158abd.jpg";